import { BUILDINGS_QUERY_KEY } from '@domain/buildings';
import { UseMutation, useMutationWrapper } from '@hooks/useMutationWrapper';
import { unpublishBuilding } from '@services/buildings/buildingsService';
import { useQueryClient } from 'react-query';

const useUnpublishBuilding = (
  venueId: string
): UseMutation<void, Error, string, unknown> => {
  const queryClient = useQueryClient();

  return useMutationWrapper<void, Error, string>(
    (buildingId) => unpublishBuilding(buildingId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(BUILDINGS_QUERY_KEY(venueId));
      }
    }
  );
};

export { useUnpublishBuilding };
